import React from "react";
import styled, { css } from "styled-components";
import { HtmlContent } from "./Content";

const TitleStyles = styled.div`
  ${({ ...props }) => css`
    font-size: 1.5rem
  `}
`;

export default function Title({ title, classes }) {
  if (title && title.text) {
    const Element = title.element.toLowerCase() || "div";
    return (
      <TitleStyles>
        <Element className={classes}>
          <HtmlContent htmlString={title.text} />
        </Element>
      </TitleStyles>
    );
  }
};
